export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/th.5f5515bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};